<template>
    <article>
        <p>
            Coroot groups individual containers into applications using the following approach:
        </p>

        <ul>
            <li>Kubernetes metadata: Pods are grouped into Deployments, StatefulSets, etc.</li>
            <li>Non-Kubernetes containers: Containers such as Docker containers or Systemd units are grouped into applications by their names. For example, Systemd services named mysql on different hosts are grouped into a single application called mysql.</li>
        </ul>

        <p>This default approach works well in most cases.
            However, since no one knows your system better than you do, Coroot allows you to manually adjust application
            groupings to better fit your specific needs. You can match desired application instances by defining
            <a href="https://en.wikipedia.org/wiki/Glob_(programming)" target="_blank">glob patterns</a> for <var>instance_name</var>.
            Note that this is not applicable to Kubernetes applications.
        </p>

        <p>
            For example, if you have 10 Apache HTTPD instances running on 10 nodes as systemd services,
            Coroot typically groups them into one application by their unit name.
            If this grouping isn't accurate for your setup, you can create custom applications and define the instance
            mapping to better match your system design.
        </p>

        <p>
            To configure Custom Application, go to the project settings (<v-icon small>mdi-cog</v-icon>),
            and click on Applications.
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/custom_apps.png" />
        </v-card>

        <h2>Quick links</h2>

        <p>
            To make organizing your apps easier, Coroot allows you to create or configure the custom application for an app directly on the application page:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/custom_apps_app_page.png" />
        </v-card>

    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
